export const JURISDICTION_CONFIG_PREFIX = "jurisdiction";
